import { FC } from 'react';
import { useAppSelector } from '../../store';
import { selectIdentity } from '../../store/entities/identity';
import { hasRole, isAnalyst, isExternal, isQcsAdminMode, isRemote, isTourniquet } from '../../utils/roles';
import { getAccessToken } from '../../utils/storage';
import { Analytics } from '../analytics/Analytics';
import { Dashboard } from '../dashboard/Dashboard';
import { EmergencyDetailRemote } from '../emergency/EmergencyDetailRemote';
import { Invitation } from '../invitation/Invitation';
import { QcsAdminCompany } from '../qcsAdmin/company/QcsAdminCompany';
import { TourniquetRoutes } from '../tourniquet/TourniquetRoutes';
import { Login } from './Login';
import { UserRole } from '@api/models/enums/UserRole';

interface Props {
  roles?: UserRole[];
  children: React.ReactNode;
}

export const AuthRoute: FC<Props> = ({ roles, children }) => {
  const identity = useAppSelector(selectIdentity);
  const token = getAccessToken();

  if (!token) {
    return <Login />;
  }

  if (!hasRole(identity.roles, roles)) {
    if (isQcsAdminMode(identity)) {
      return <QcsAdminCompany />;
    }

    if (isTourniquet(identity)) {
      return <TourniquetRoutes />;
    }

    if (isExternal(identity)) {
      return <Invitation />;
    }

    if (isRemote(identity)) {
      return <EmergencyDetailRemote />;
    }

    if (isAnalyst(identity)) {
      return <Analytics />;
    }

    return <Dashboard />;
  }

  return <>{children}</>;
};
